import React, { useContext } from 'react';
import { Route, Switch } from 'react-router-dom';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import NavBarWithRouter from './components/NavBar';
import FloatingIcons from './FloatingIcons'; // Composant pour les icônes flottantes
import Home from './components/Home';
import Services from './components/Services';
import Projects from './components/Projects';

import About from './components/About';
import Contact from './components/Contact';
import EInvoicingPage from './components/EInvoicingPage';
import AppContext from './AppContext';
import { getTranslation } from './constants/translations';
import './App.css'; // Styles globaux

function MainApp() {
  const { language } = useContext(AppContext);
  const t = getTranslation(language);

  return (
    <div className="MainApp">
      <NavBarWithRouter />
      <Switch>
        <Route exact path="/facturation-numerique">
          <EInvoicingPage />
        </Route>
        <Route path="/">
          <main className="sections-container">
            <TransitionGroup>
              <CSSTransition classNames="fade" timeout={1000} appear>
                <div>
                  <section id="home">
                    <Home />
                  </section>
                  <section id="services">
                    <Services header={t.sections.services} />
                  </section>
                  <section id="projects">
                    <Projects header={t.sections.projects} />
                  </section>
                  <section id="contact">
                    <Contact title={t.sections.contact} />
                  </section>
                  <section id="about">
                    <About header={t.sections.about} />
                  </section>
                </div>
              </CSSTransition>
            </TransitionGroup>
          </main>
        </Route>
      </Switch>
      <FloatingIcons />
    </div>
  );
}

export default MainApp;
